export default __webpack_public_path__ + "static/media/icono-coaseguro.5487ac37.svg";